import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { FolderKanban } from "lucide-react";
import TrashIcon from "../../../assets/icons/TrashIcon";
import Spinner from "../../../assets/icons/Spinner";
import Message from "../../../i18n/Message";
import { deleteProject } from "../store/builderActionCreators";
import { builderSelectors } from "../store/builderReducer";
import { linkToBuilderProject } from "../../../routes";

import "./ProjectTile.scss";

const STATUS_LABELS = {
  CREATED: "Created",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  DEPLOYED: "Deployed",
  ERROR: "Error",
};

const STATUS_COLORS = {
  CREATED: "#6c757d",
  IN_PROGRESS: "#0d6efd",
  COMPLETED: "#198754",
  DEPLOYED: "#198754",
  ERROR: "#dc3545",
};

const ProjectTile = ({ project }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const nav = useNavigate();
  const { workspaceId } = useParams();
  const deletingProjectUid = useSelector(builderSelectors.getDeletingProjectUid);
  const isDeleting = deletingProjectUid === project.uid;

  const onDeleteConfirmed = (e) => {
    e.stopPropagation();
    dispatch(
      deleteProject(intl, workspaceId, project.uid, () => {
        setShowDeleteConfirm(false);
      })
    );
  };

  const handleClick = () => {
    if (project.chatUid) {
      nav(linkToBuilderProject(workspaceId, project.chatUid));
    }
  };

  return (
    <div className="campaign_tile card project_tile border-radius-lg d-flex">
      <div className="d-flex flex-column tile_body" onClick={handleClick}>
        <div className="tile-name">
          <FolderKanban size={24} color="#344767" />
          <span>{project.name}</span>
        </div>
        <div className="tile-info">
          <span
            className="info-item status-badge"
            style={{ backgroundColor: STATUS_COLORS[project.status] || "#6c757d" }}
          >
            {STATUS_LABELS[project.status] || project.status}
          </span>
          {project.subdomain && (
            <span className="info-item subdomain">
              {project.subdomain}.apps.promptleo.com
            </span>
          )}
        </div>
        <div className="metadata_row">
          <div className="meta_name">
            <Message id="created_on" />
          </div>
          <div className="meta_value">
            {dayjs(project.dateCreated).format("LLL")}
          </div>
        </div>
      </div>
      <div className="d-flex tile-actions">
        <div className="confirm_container">
          {showDeleteConfirm && (
            <>
              <div
                className="cover"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDeleteConfirm(false);
                }}
              ></div>
              <div className="confirm_panel">
                <button
                  className="btn bg-gradient-primary btn-sm"
                  onClick={onDeleteConfirmed}
                  disabled={isDeleting}
                >
                  {isDeleting ? <Spinner size={16} /> : <Message id="confirm_delete" />}
                </button>
              </div>
            </>
          )}
        </div>
        <button
          className="btn no-btn tile-action"
          disabled={isDeleting}
          onClick={(e) => {
            e.stopPropagation();
            setShowDeleteConfirm(!showDeleteConfirm);
          }}
        >
          <TrashIcon size="16" color="#344767" />
          <Message id="delete" />
        </button>
      </div>
    </div>
  );
};

export default ProjectTile;
